import Vue from 'vue'

/**
 * @author José Luis R. <jose.ruiz@jbge.com.mx>
 *
 * Updates rejected photos from an affected
 *
 * @param  payload File and id
 * @return {Array} File's info
 */

const updateSecurityPhotos = payload =>
  Vue.$http.post('workplan/security-photo/replace/', payload)
    .then()
    .catch((err) => {
      throw err
    })

export default updateSecurityPhotos


// WEBPACK FOOTER //
// ./src/services/workPlan/updateSecurityPhotos.js